<div class="container-fluid">
  <app-pagetitle title="Day Report" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
  <div class="row">
    <div class="col-xl-12">
      <div class="row">
        <div class="form-group col-md-2">
          <label>Department</label>
          <select class="form-control custom-select" name="departmentName" id="departmentName" ngModel
            disableOptionCentering (ngModelChange)="select_Department($event)" [(ngModel)]="selectedDepartment">
            <option *ngFor="let department of departmentData" [ngValue]="department.departmentName">
              {{ department.departmentName }}
            </option>
          </select>
        </div>
        <div class="form-group col-md-2">
          <label>Shift</label>
          <select class="form-control custom-select" name="shiftName" id="shiftName" ngModel disableOptionCentering
            (ngModelChange)="select_Shift($event)" [(ngModel)]="selectedShift">
            <option *ngFor="let shift of shiftData" [ngValue]="shift.shiftName">
              {{ shift.shiftName }}
            </option>
          </select>
        </div>
        <div class="form-group col-md-2">
          <label>Date</label>
          <input class="form-control" type="date" [(ngModel)]="fromDate" (ngModelChange)="select_Date($event)"
            placeholder="{{ 'From-date' }}" id="example-date-input" [min]="mindate" [max]="maxdate" />
        </div>
        <div class="col-md-1">
          <button style="width: 100%; margin-top: 1.8rem" type="button" class="btn btn-success btn-rounded"
            (click)="getData()">
            Submit
          </button>
        </div>
        <div class="col-md-1" *ngIf="tableData?.machines?.length">
          <button type="button" style="width: 100%; margin-top: 1.8rem" class="btn btn-primary btn-rounded"
            (click)="openModal(templatepdf, 'downloadpdfcsv', 'Export')">
            Export
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-2">
      <div class="card">
        <div class="card-body d-flex justify-content-around align-items-center">
          <i class="mdi mdi-flash mdi-36px me-3 text-warning"></i>
          <div>
            <h6 class="fw-bold mb-1">
              {{ tableData?.summary?.EnergyConsumed || 0 }} KWH
            </h6>
            <p class="form-label mb-0">Total Energy</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-2">
      <div class="card">
        <div class="card-body d-flex justify-content-around align-items-center">
          <i class="mdi mdi-calendar-check mdi-36px me-3 text-primary"></i>
          <div>
            <h6 class="fw-bold mb-1">
              {{ tableData?.summary?.Partplanned || 0 }}
            </h6>
            <p class="form-label mb-0">Planned Part</p>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-2">
      <div class="card">
        <div class="card-body d-flex justify-content-around align-items-center">
          <i class="mdi mdi-factory mdi-36px me-3 text-success"></i>
          <div>
            <h6 class="fw-bold mb-1">
              {{ tableData?.summary?.PartProduced || 0 }}
            </h6>
            <p class="form-label mb-0">Part Produced</p>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-2">
      <div class="card">
        <div class="card-body d-flex justify-content-around align-items-center">
          <i class="mdi mdi-close-circle mdi-36px me-3 text-danger"></i>
          <div>
            <h6 class="fw-bold mb-1">
              {{ tableData?.summary?.PartRejected || 0 }}
            </h6>
            <p class="form-label mb-0">Part Rejected</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-2">
      <div class="card">
        <div class="card-body d-flex justify-content-around align-items-center">
          <i class="mdi mdi-calendar-clock mdi-36px me-3 text-info"></i>
          <div>
            <h6 class="fw-bold mb-1">
              {{ tableData?.summary?.AvailableTime || 0 }}
            </h6>
            <p class="form-label mb-0">AvailableTime</p>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-2">
      <div class="card">
        <div class="card-body d-flex justify-content-around align-items-center">
          <i class="mdi mdi-timer-off mdi-36px me-3 text-secondary"></i>
          <div>
            <h6 class="fw-bold mb-1">
              {{ tableData?.summary?.Downtime || "00:00:00" }}
            </h6>
            <p class="form-label mb-0">Downtime</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-8 d-flex flex-column">
      <div class="row" style="margin-top: -15px">
        <div class="col-md-3">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <label class="mb-0">Availability</label>
                <span>{{ tableData?.summary?.Availability || 0 }} %</span>
              </div>
              <ngb-progressbar [value]="tableData?.summary?.Availability" type="success"></ngb-progressbar>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <label class="mb-0">Performance</label>
                <span>{{ tableData?.summary?.Performance || 0 }} %</span>
              </div>
              <ngb-progressbar [value]="tableData?.summary?.Performance" type="primary"></ngb-progressbar>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <label class="mb-0">Quality</label>
                <span>{{ tableData?.summary?.Quality || 0 }} %</span>
              </div>
              <ngb-progressbar [value]="tableData?.summary?.Quality" type="warning"></ngb-progressbar>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <label class="mb-0">OEE</label>
                <span>{{ tableData?.summary?.Oee || 0 }} %</span>
              </div>
              <ngb-progressbar [value]="tableData?.summary?.Oee || 0" type="secondary"></ngb-progressbar>
            </div>
          </div>
        </div>
      </div>
      <div class="card flex-fill" style="margin-top: -15px">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <div class="h6 mb-0">
              <ng-container *ngIf="selectedPameterType !== 'Downtime'">Hourly </ng-container>{{ selectedPameterType }}
            </div>
            <div>
              <select class="form-control" name="selectedPameter" id="selectedPameter" [(ngModel)]="selectedPameterType"
                (change)="selectPameterType()" style="color: black; min-width: 150px">
                <option value="OEE">OEE</option>
                <option value="Energy">Energy</option>
                <option value="Production">Production</option>
                <option value="Downtime">Downtime</option>
              </select>
            </div>
          </div>
          <div echarts [options]="hourlyOEE" class="chart-container" style="width: 100%; height: 150px"></div>
        </div>
      </div>
    </div>
    <div class="col-md-4 d-flex flex-column" style="margin-top: -15px">
      <div class="card flex-fill">
        <div class="card-body">
          <div echarts [options]="productionOperation" class="chart-container"
            style="width: 100%; height: 100%; min-height: 200px"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="tableData['downtimedata']?.length">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <!-- <div class="d-flex justify-content-between align-items-center">
            <div class="h6 mb-0">
              {{ selectedType }} Analysis
            </div>
            <div class="d-flex gap-2">

              <select class="form-control" [(ngModel)]="selectedType" (change)="selectType($event.target.value)"
                style="color: black; min-width: 150px;">
                <option *ngFor="let param of parameterOptions" [value]="param">
                  {{ param }}
                </option>
              </select>
              <ng-multiselect-dropdown [placeholder]="'Select Machine'" [settings]="settings" [data]="dropdownList"
                [(ngModel)]="selectedMachines" (onSelect)="onMachineSelect()" (onDeSelect)="onMachineSelect()"
                (onSelectAll)="onMachineSelect($event)" (onDeSelectAll)="onMachineSelect($event)"
                style="min-width: 150px;">
              </ng-multiselect-dropdown>
            </div>
          </div> -->
          <div class="d-flex flex-wrap justify-content-between align-items-center gap-2">
            <div class="h6 mb-0 flex-grow-1">{{ selectedType }} Analysis</div>
            <div class="d-flex flex-wrap flex-lg-nowrap gap-2">
              <!-- <select class="form-control flex-grow-1" [(ngModel)]="selectedType"
                (change)="selectType($event.target.value)" style="color: black; min-width: 150px;">
                <option *ngFor="let param of parameterOptions" [value]="param">
                  {{ param }}
                </option>
              </select> -->

              <ng-multiselect-dropdown class="flex-grow-1" [placeholder]="'Select Machine'" [settings]="settings"
                [data]="dropdownList" [(ngModel)]="selectedMachines" (onSelect)="onMachineSelect()"
                (onDeSelect)="onMachineSelect()" (onSelectAll)="onMachineSelect($event)"
                (onDeSelectAll)="onMachineSelect($event)" style="min-width: 150px">
              </ng-multiselect-dropdown>
            </div>
          </div>

          <div class="chart-scroll">
            <div [options]="oeeAnalysis" class="demo-chart1" echarts></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <!-- <div class="card-header"
          style="display: flex; justify-content: space-between;align-items: center;background-color: #b5d8d7;height: 60px;">
          <div style="font-weight: bold;color: black;">Department</div>
          <div class="col-md-2 mt-3">
            <div class="form-group">
              <select class="form-control custom-select" (ngModelChange)="select_Department($event)"
                name="departmentName" id="departmentName" ngModel disableOptionCentering
                [(ngModel)]="selectedDepartment">
                <option *ngFor="let department of departmentData" [ngValue]="department.departmentName">
                  {{ department.departmentName }}
                </option>
              </select>
            </div>
          </div>
        </div> -->
        <div class="card-header" style="background-color: #0e7d79 !important; color: white">
          OEE
        </div>
        <div class="card-body">
          <div *ngIf="!showTable" class="text-center text-muted">
            Please wait, we are fetching data.
          </div>
          <div *ngIf="tableData['machines']?.length > 0" class="table-responsive table-container">
            <table class="table table-striped table-bordered table-centered datatable dt-responsive nowrap mb-0">
              <thead class="thead-dark">
                <tr>
                  <th>Machine Name</th>
                  <th>Shift</th>
                  <th>Available Time (hrs)</th>
                  <th>Running (hrs)</th>
                  <th>Idle (hrs)</th>
                  <th *ngIf="hasmchBreakdown">Breakdown (hrs)</th>
                  <th *ngIf="hasmchInterlock">Interlock (hrs)</th>
                  <th>Off (hrs)</th>
                  <th>Downtime (hrs)</th>
                  <th>Qty Planned</th>
                  <th *ngIf="!hasmchpin2">Qty Produced</th>
                  <th *ngIf="hasmchpin2">Part Count 1</th>
                  <th *ngIf="hasmchpin2">Part Count 2</th>
                  <th>Qty Rejected</th>
                  <th>Availability(%)</th>
                  <th>Performance(%)</th>
                  <th>Quality(%)</th>
                  <th>Oee(%)</th>
                  <th>Total Energy (kWh)</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="
                    let machine of tableData['machines']
                      | slice : pageSize
                      | slice : 0 : itemsPerPage
                  ">
                  <td>{{ machine?.Machine || "-" }}</td>
                  <td>{{ machine?.ShiftName || "-" }}</td>
                  <td>{{ formatMinutesToHHMMSS(machine.AvailableTime) }}</td>
                  <td>{{ formatMinutesToHHMMSS(machine.RunningTime) }}</td>
                  <td>{{ formatMinutesToHHMMSS(machine.IdleTime) }}</td>
                  <td *ngIf="hasmchBreakdown">
                    {{ getTimeOrNA(machine, 'BreakdownTime') }}
                  </td>

                  <td *ngIf="hasmchInterlock">
                    {{ getTimeOrNA(machine, 'InterlockTime') }}
                  </td>

                  <td>{{ formatMinutesToHHMMSS(machine.OffTime) }}</td>
                  <td>{{ formatMinutesToHHMMSS(machine.Downtime) }}</td>
                  <td>{{ machine?.Partplanned || 0 }}</td>
                  <!-- <td>{{ machine?.PartProduced || 0 }}</td> -->
                  <td *ngIf="!hasmchpin2">{{ machine?.Pin1Count || 0 }}</td>
                  <td *ngIf="hasmchpin2">{{ machine?.Pin1Count || 0 }}</td>
                  <td *ngIf="hasmchpin2">{{ machine?.Pin2Count || 0 }}</td>
                  <td>{{ machine?.PartRejected || 0 }}</td>
                  <td>{{ machine?.Availability || 0 }}</td>
                  <td>{{ machine?.Performance || 0 }}</td>
                  <td>{{ machine?.Quality || 0 }}</td>
                  <td>{{ machine?.Oee || 0 }}</td>
                  <td>{{ machine?.EnergyConsumed || 0 }}</td>
                </tr>
              </tbody>
            </table>

            <div class="col-md-6">
              <ngb-pagination class="pagination-rounded" [collectionSize]="tableData['machines']?.length"
                [pageSize]="itemsPerPage" [(page)]="currentPage" [maxSize]="1" [rotate]="true" [ellipses]="false"
                [boundaryLinks]="true" (pageChange)="onPageChange($event)">
              </ngb-pagination>
            </div>
          </div>
          <div *ngIf="
              showTable &&
              (!tableData['machines'] || tableData['machines'].length === 0)
            " class="text-center text-muted">
            No data available for the selected Date and Depatment, as no
            production planning was scheduled.
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header" style="background-color: #0e7d79 !important; color: white">
          Downtime Entry
        </div>
        <div class="card-body">
          <div *ngIf="!showTable" class="text-center text-muted">
            Please wait, we are fetching data.
          </div>
          <div *ngIf="tableData['downtimeReasonData']?.length > 0" class="table-responsive table-container">
            <table class="table table-striped table-bordered">
              <thead class="thead-dark">
                <tr>
                  <th>
                    <div class="d-flex justify-content-between align-items-center">
                      <span>Machine Name</span>
                      <div ngbDropdown class="btn-group">
                        <i class="mdi mdi-filter" ngbDropdownToggle></i>
                        <div ngbDropdownMenu>
                          <button class="dropdown-item" (click)="filters.machineName = ''; applyFilters()">
                            All
                          </button>
                          <button class="dropdown-item" *ngFor="let opt of machineOptions"
                            (click)="filters.machineName = opt; applyFilters()">
                            {{ opt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class="d-flex justify-content-between align-items-center">
                      <span>Shift Name</span>
                      <div ngbDropdown class="btn-group">
                        <i class="mdi mdi-filter" ngbDropdownToggle></i>
                        <div ngbDropdownMenu>
                          <button class="dropdown-item" (click)="filters.shiftName = ''; applyFilters()">
                            All
                          </button>
                          <button class="dropdown-item" *ngFor="let opt of shiftOptions"
                            (click)="filters.shiftName = opt; applyFilters()">
                            {{ opt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class="d-flex justify-content-between align-items-center">
                      <span>Status</span>
                      <div ngbDropdown class="btn-group">
                        <i class="mdi mdi-filter" ngbDropdownToggle></i>
                        <div ngbDropdownMenu>
                          <button class="dropdown-item" (click)="filters.status = ''; applyFilters()">
                            All
                          </button>
                          <button class="dropdown-item" *ngFor="let opt of statusOptions"
                            (click)="filters.status = opt; applyFilters()">
                            {{ opt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>
                  <th>Time (hrs)</th>
                  <th>Duration (hrs)</th>
                  <th>
                    <div class="d-flex justify-content-between align-items-center">
                      <span>Reason</span>
                      <div ngbDropdown class="btn-group">
                        <i class="mdi mdi-filter" ngbDropdownToggle></i>
                        <div ngbDropdownMenu>
                          <button class="dropdown-item" (click)="filters.reason = ''; applyFilters()">
                            All
                          </button>
                          <button class="dropdown-item" *ngFor="let opt of reasonOptions"
                            (click)="filters.reason = opt; applyFilters()">
                            {{ opt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class="d-flex justify-content-between align-items-center">
                      <span>SubReason</span>
                      <div ngbDropdown class="btn-group">
                        <i class="mdi mdi-filter" ngbDropdownToggle></i>
                        <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
                          <button class="dropdown-item" (click)="filters.subreason = ''; applyFilters()">
                            All
                          </button>
                          <button class="dropdown-item" *ngFor="let opt of subreasonOptions"
                            (click)="filters.subreason = opt; applyFilters()">
                            {{ opt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="
                    let machine of filteredData
                      | slice : downtimepageSize
                      | slice : 0 : downtimeitemsPerPage
                  ">
                  <td>{{ machine?.machineName || '-' }}</td>
                  <td>{{ machine?.shiftName || '-'}}</td>
                  <td>{{ machine?.status || '-'}}</td>
                  <td>
                    {{
                    machine.reason !== "Not Specified"
                    ? machine.fromTime + " - " + machine.toTime
                    : "Unavailable"
                    }}
                  </td>

                  <td>{{ machine?.duration || '00:00:00'}}</td>
                  <td>{{ machine?.reason || 'NA'}}</td>
                  <td>{{ machine?.subreason || 'NA' }}</td>
                </tr>
              </tbody>
            </table>
            <div class="col-md-6">
              <ngb-pagination class="pagination-rounded" [collectionSize]="filteredData?.length"
                [pageSize]="downtimeitemsPerPage" [(page)]="currendowntimetPage" [maxSize]="1" [rotate]="true"
                [ellipses]="false" [boundaryLinks]="true" (pageChange)="ondowntimePageChange($event)">
              </ngb-pagination>
            </div>
          </div>
          <div *ngIf="
              showTable &&
              (!tableData['downtimeReasonData'] ||
                tableData['downtimeReasonData'].length === 0)
            " class="text-center text-muted">
            No data available for the selected Date and Depatment, as no
            production planning was scheduled.
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header" style="background-color: #0e7d79 !important; color: white">
          Rejection Entry
        </div>
        <div class="card-body">
          <div *ngIf="!showTable" class="text-center text-muted">
            Please wait, we are fetching data.
          </div>
          <div *ngIf="tableData['rejectionReasonData']?.length > 0" class="table-responsive table-container">
            <table class="table table-striped table-bordered">
              <thead class="thead-dark">
                <tr>
                  <th>
                    <div class="d-flex justify-content-between align-items-center">
                      <span>Machine Name</span>
                      <div ngbDropdown class="btn-group">
                        <i class="mdi mdi-filter" ngbDropdownToggle></i>
                        <div ngbDropdownMenu>
                          <button class="dropdown-item" (click)="
                              rejectionfilters.machineName = '';
                              applyrejectionFilters()
                            ">
                            All
                          </button>
                          <button class="dropdown-item" *ngFor="let opt of machinerejectionOptions" (click)="
                              rejectionfilters.machineName = opt;
                              applyrejectionFilters()
                            ">
                            {{ opt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class="d-flex justify-content-between align-items-center">
                      <span>Shift Name</span>
                      <div ngbDropdown class="btn-group">
                        <i class="mdi mdi-filter" ngbDropdownToggle></i>
                        <div ngbDropdownMenu>
                          <button class="dropdown-item" (click)="
                              rejectionfilters.shiftName = '';
                              applyrejectionFilters()
                            ">
                            All
                          </button>
                          <button class="dropdown-item" *ngFor="let opt of shiftrejectionOptions" (click)="
                              rejectionfilters.shiftName = opt;
                              applyrejectionFilters()
                            ">
                            {{ opt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class="d-flex justify-content-between align-items-center">
                      <span>Reason</span>
                      <div ngbDropdown class="btn-group">
                        <i class="mdi mdi-filter" ngbDropdownToggle></i>
                        <div ngbDropdownMenu>
                          <button class="dropdown-item" (click)="
                              rejectionfilters.reason = '';
                              applyrejectionFilters()
                            ">
                            All
                          </button>
                          <button class="dropdown-item" *ngFor="let opt of reasonrejectionOptions" (click)="
                              rejectionfilters.reason = opt;
                              applyrejectionFilters()
                            ">
                            {{ opt }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </th>

                  <th>Count</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="
                    let machine of rejectionfilteredData
                      | slice : rejectionpageSize
                      | slice : 0 : rejectionitemsPerPage
                  ">
                  <td>{{ machine?.machineName || '-' }}</td>
                  <td>{{ machine?.shiftName|| '-' }}</td>
                  <td>{{ machine?.reason || '-' }}</td>
                  <td>{{ machine?.count|| '0' }}</td>
                </tr>
              </tbody>
            </table>
            <div class="col-md-6">
              <ngb-pagination class="pagination-rounded" [collectionSize]="rejectionfilteredData?.length"
                [pageSize]="rejectionitemsPerPage" [(page)]="currenrejectiontPage" [maxSize]="1" [rotate]="true"
                [ellipses]="false" [boundaryLinks]="true" (pageChange)="onrejectionPageChange($event)">
              </ngb-pagination>
            </div>
          </div>
          <div *ngIf="
              showTable &&
              (!tableData['rejectionReasonData'] ||
                tableData['rejectionReasonData'].length === 0)
            " class="text-center text-muted">
            No data available for the selected Date and Depatment, as no
            production planning was scheduled.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #templatepdf role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">{{ action }}</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal('Cross click'); cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body card-body">
    <div class="example-container">
      <ul ngbNav #justifiednav="ngbNav" [activeId]="1" class="nav-pills nav-justified">
        <li (click)="directExpo()" [ngbNavItem]="1">
          <a ngbNavLink>
            <h6 class="">Direct Export</h6>
          </a>
          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="directExport"></ng-template>
          </ng-template>
        </li>
        <li (click)="mailexport()" [ngbNavItem]="2">
          <a ngbNavLink>
            <h6 class="">Export via Email</h6>
          </a>
          <ng-template ngbNavContent>
            <ng-template [ngTemplateOutlet]="mailExport"></ng-template>
          </ng-template>
        </li>
      </ul>
      &nbsp;&nbsp;
      <div [ngbNavOutlet]="justifiednav"></div>
      <div class="text-right mt-3">
        <button *ngIf="!exportViaMail" type="submit" class="btn btn-info round waves-effect headr"
          (click)="modal('Cross click'); download()">
          Export
        </button>
        <button *ngIf="exportViaMail" type="submit" class="btn btn-info round waves-effect headr"
          (click)="modal('Cross click'); download()" [disabled]="!mailform.get('email').value">
          Export
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #directExport>
  <form>
    <div>
      <p>Select the file type you would like to export</p>
    </div>
    <span class="pdf" [ngStyle]="{ 'background-color': pdfBool ? '#C4A484' : null }"><i class="fas fa-file-pdf"
        (click)="pdf()"> PDF </i></span>&nbsp;&nbsp;
    <span class="csv" [ngStyle]="{ 'background-color': csvBool ? '#90EE90' : null }"><i class="fas fa-file-csv"
        (click)="csv()"> CSV </i></span>
    &nbsp;&nbsp;
  </form>
</ng-template>
<ng-template #mailExport>
  <div>
    <p>Select the file type you would like to export</p>
  </div>
  <span class="pdf" [ngStyle]="{ 'background-color': pdfBool ? '#C4A484' : null }"><i class="fas fa-file-pdf"
      (click)="pdf()"> PDF </i></span>&nbsp;&nbsp;
  <span class="csv" [ngStyle]="{ 'background-color': csvBool ? '#90EE90' : null }"><i class="fas fa-file-csv"
      (click)="csv()"> CSV </i></span>&nbsp;&nbsp;
  <div>
    <form [formGroup]="mailform">
      <div class="form-group col-md-8">
        &nbsp;&nbsp;

        <input class="form-control" id="email" placeholder="user@gmail.com" formControlName="email" required
          [ngClass]="{ 'is-invalid': isEmailInvalid() }" />
        <div *ngIf="isEmailInvalid()">
          <span *ngIf="email.hasError('required')" style="color: red">Email is required</span>
          <span *ngIf="email.hasError('email')" style="color: red">Invalid email address</span>
        </div>
      </div>
    </form>
  </div>
</ng-template>